import Cookie from 'js-cookie';

const auth = !Cookie.get('token');

export default !auth;
